import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
// import pay from "../Assets/pay.png";
// import pay2 from "../Assets/Group 2644.png";
// import pay3 from "../Assets/master.png";
import profile from "../Assets/prof.png";
import { getSinglePackage, bookPackage, createPackagePaymentOrder } from "../Common/apis.js";
import Loader from "../Common/Loader.jsx";
import { toast } from "react-toastify";

function PackageBooking() {
  const { packageId } = useParams();
  const navigate = useNavigate();
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isBooking, setIsBooking] = useState(false);

  useEffect(() => {
    checkLoginStatus();
    fetchPackageData();
  }, []);

  const checkLoginStatus = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!isLoggedIn || isLoggedIn !== "true") {
      alert("Please Login First.");
      navigate(-1);
    }
  };

  const fetchPackageData = async () => {
    try {
      const result = await getSinglePackage(packageId);
      setPackageData(result?.data);
    } catch (error) {
      console.error("Error fetching package:", error);
      toast.error("Failed to load package details.");
    } finally {
      setLoading(false);
    }
  };

  const handleBooking = async () => {
    const token = localStorage.getItem("AluraToken");
    if (!token) {
      alert("Authentication failed! Please login again.");
      navigate("/");
      return;
    }
    
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    const bookingData = {
      packageId: packageData?._id,
      paymentStatus: "Completed",
      transactionId: "Admin Purchase"
    };
    
    setIsBooking(true);
    try {
      const res = await bookPackage(bookingData, headers);
      if (res?.statusCode === 200) {
        const paymentData = await createPackagePaymentOrder({
          packageBookingId: res?.data?._id,
          amount: Number(packageData?.amount) * 100,
          currency: "AED"
        });
        if (paymentData?.payment_url) {
          window.location.href = paymentData.payment_url;
        } else {
          toast.error(paymentData?.message || "Payment initiation failed.");
        }
      }
    } catch (error) {
      console.error("Booking failed:", error);
      toast.error("Booking failed! Please try again.");
    } finally {
      setIsBooking(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Navbar />
      {isBooking && <Loader />}
      <div className="aboutbanner">
        <h3>Checkout</h3>
        <p>HOME - BOOK CLASSES - REFORM METHOD-CHECKOUT</p>
      </div>
      <div className="checkout checkout2">
        {/* <div className="checkout-left"> */}
          {/* <div className="Package">
            <p>{packageData?.name} Package</p>
          </div> */}
          
          {/* <h3>Payment Method</h3>
          <br/>

          <div className="PaymentMethod">
            <img src={pay} alt="Payment Method 1" />
            <img src={pay2} alt="Payment Method 2" />
            <img src={pay3} alt="Payment Method 3" />
          </div> */}
        {/* </div> */}

        <div className="checkout-right checkout-right2">
          <div className="checkout-profile">
            <img src={profile} alt="Profile" />
            <div>
              <h3>
                {packageData?.name} ({packageData?.packageDuration} Days)
              </h3>
              <p>Classes: {packageData?.packageType === "Counted" ? `${packageData?.noOfDays}` : "Unlimited"}</p>
            </div>
          </div>
          <div className="checkout-bill">
            <h3>Bill Details</h3>
          <br/>

            <div className="subtotal">
              <p>Package Price</p>
              <p><b>AED {packageData?.amount}</b></p>
            </div>
          <br/>

            <div className="subtotal">
              <p>Tax (0%)</p>
              <p><b>AED {(packageData?.amount * 0.0).toFixed(2)}</b></p>
            </div>
          <br/>

            <div className="subtotal">
              <p>Total</p>
              <p><b>AED {(packageData?.amount * 1.0).toFixed(2)}</b></p>
            </div>
          <br/>

            <button onClick={handleBooking} disabled={isBooking}>Buy Now</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PackageBooking;